import { useCallback } from "react";
import { CellValueChangedEvent } from "ag-grid-community";
import { HRM3050_R01DetailDto, HRM3050_R01HeaderDto } from "../Dto_HRM3050_R01";

/** Table에서 전달받는 값의 모양이다. T는 근무조 또는 휴게 행 타입이다. */
interface Props<T> {
    updateRow: (index: number, data: T) => void; // 이벤트가 난 그리드(근무조 또는 휴게)의 행 교체 함수
}

/**
 * 일반 셀 편집 결과를 Store에 반영하는 화면 전용 훅이다. 근무조·휴게 그리드가 각자의 updateRow로 함께 쓴다.
 * 시각 형식 정리는 각 컬럼의 valueParser가 먼저 처리하므로 여기서는 값과 수정 표시만 반영한다.
 * @returns 그리드 onCellValueChanged에 연결할 handleCellChange
 */
export const useHRM3050_R01CellChange = <T extends HRM3050_R01HeaderDto | HRM3050_R01DetailDto>({ updateRow }: Props<T>) => {
    /** 변경된 필드와 값을 반영한다. 유효하지 않은 행·필드는 무시하고 반환값은 없다. */
    const handleCellChange = useCallback((event: CellValueChangedEvent<T>) => {
        // 구조 분해: 이벤트에서 행 데이터, 컬럼 정의, 새 값을 꺼낸다.
        const { data, colDef, newValue } = event;
        // 합계 행 등 실제 데이터가 없거나 필드가 없는 이벤트는 처리하지 않는다.
        if (!data || !colDef.field) return;
        // 펼치기(...): 기존 행을 복사한 뒤 바뀐 필드와 수정 표시만 덮어쓴다.
        updateRow(data.valueIndex, { ...data, [colDef.field]: newValue, isModified: true });
    }, [updateRow]);

    // Table에서 이벤트 핸들러를 연결할 수 있도록 반환한다.
    return { handleCellChange };
};
